import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatMinutesHours'
})
export class FormatMinutesHoursPipe implements PipeTransform {
    transform(value: any, args?: any): any {
        let timeString = '';
        let hours = Math.floor(Number(value) / 60);
        const minutes = Number(value) % 60;

        timeString = `${ hours ? hours + 'h ' : '' }${ minutes ? minutes + 'm' : '0m' }`;

        if(args==='includeDays')
        {
          const days = hours>24?Math.floor(Number(hours)/24):0;
          const dayStr = days>0?days+'d ':'';

          hours = hours - (days*24);

          timeString = `${ dayStr }${ hours ? hours + 'h ' : '' }${ minutes ? minutes + 'm' : '0m' }`;
        }



        return timeString;
    }
}
